import { render, staticRenderFns } from "./processAccidentTab.vue?vue&type=template&id=2248e178"
import script from "./processAccidentTab.vue?vue&type=script&lang=js"
export * from "./processAccidentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2248e178')) {
      api.createRecord('2248e178', component.options)
    } else {
      api.reload('2248e178', component.options)
    }
    module.hot.accept("./processAccidentTab.vue?vue&type=template&id=2248e178", function () {
      api.rerender('2248e178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/processAccidentTab.vue"
export default component.exports